export var Place;
(function (Place) {
    Place["SERP_PAGE"] = "SERP_PAGE";
    Place["SERP_MAP"] = "SERP_MAP";
})(Place || (Place = {}));
export const postViewedClassifieds = async ({ bffUri, analyticsData }) => {
    await fetch(`${bffUri}analytics/viewed`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            type: 'CLASSIFIED_VIEWED',
            source: 'SERP',
            ...analyticsData,
        }),
    });
};
